// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3KGY0","setting":"style_setting__3h82P","title":"style_title__2FrFN","itemTitle":"style_itemTitle__2MJZm"};